export const variantServiceProductEndpointEnabled = 'products-endpoint-variant-service-integration-enabled';
export const variantServiceProductFiltersEnabled = 'product-filters-service-endpoint-enabled';
export const netSuiteSupplierOnboarding = 'net-suite-supplier-onboarding';
export const salesforceSupplierOnboarding = 'salesforce-supplier-onboarding';
export const showMSRPPrices = 'show-msrp-wsp-prices';
export const suppliersWhoShouldUseAccountIdConfigModal = 'should_use_account_id_config';
export const showPricesRetailerSide = 'show-prices-retailer-side';
export const tempHideHasPricePricingFilterSupplierIds = 'temp-hide-pricing-has-price-supplier-ids';
export const uiProductsFeedsPage = 'ui-products-feeds-page';
